import { render, staticRenderFns } from "./perInfoManage.vue?vue&type=template&id=398af058&scoped=true"
import script from "./perInfoManage.js?vue&type=script&lang=js&external"
export * from "./perInfoManage.js?vue&type=script&lang=js&external"
import style0 from "./perInfoManage.scss?vue&type=style&index=0&id=398af058&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398af058",
  null
  
)

export default component.exports